import { render, staticRenderFns } from "./ItemTypeForm.vue?vue&type=template&id=5272c23a"
import script from "./ItemTypeForm.vue?vue&type=script&lang=js"
export * from "./ItemTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports